import React, { FC, useRef } from 'react';
import { Container, Grid, makeStyles, Theme } from '@material-ui/core';
import { DescriptionItem } from 'templates/services';
import { DescriptionItemProps } from 'templates/services/DescriptionItem';
import { SpacingLayout } from 'components/atoms';

interface DescriptionSectionProps {
  descriptionItems: Array<Pick<DescriptionItemProps, Exclude<keyof DescriptionItemProps, 'animationDelay'>>>;
}

const useStyles = makeStyles((theme: Theme) => ({
  gridItem: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.up('md')]: {
      '&:not(:last-child)': {
        marginBottom: theme.spacing(0),
      },
    },
  },
}));

const DescriptionSection: FC<DescriptionSectionProps> = ({ descriptionItems }) => {
  const classes = useStyles();
  return (
    <>
      {!!descriptionItems.length && (
        <SpacingLayout>
          <Container maxWidth={false} fixed>
            <Grid container spacing={4}>
              {descriptionItems.map((item, idx) => (
                <Grid item md={4} key={idx} className={classes.gridItem}>
                  <DescriptionItem
                    svgIcon={item.svgIcon}
                    title={item.title}
                    text={item.text}
                    key={idx}
                    animationDelay={(idx + 1) * 200}
                  />
                </Grid>
              ))}
            </Grid>
          </Container>
        </SpacingLayout>
      )}
    </>
  );
};

export default DescriptionSection;
